export const errorMessages = {
  invalidOTP: 'Invalid code, please try again',
};
